import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const ContactIndustrial: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    phone: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.name.trim() || !formData.email.trim()) {
      alert('Por favor completa los campos obligatorios.');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      await emailjs.send(
        'service_xd4ew2u',
        'template_t6enc49',
        {
          from_name: formData.name,
          from_email: formData.email,
          phone: formData.phone || 'No proporcionado',
          company: formData.company || 'No proporcionado',
          message: formData.message || 'Solicitud de cotización industrial',
        },
        'l8boG2S9EroFNMbg7'
      );

      setSubmitStatus('success');
      setFormData({ name: '', company: '', phone: '', email: '', message: '' });
    } catch (error) {
      console.error('Error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contacto" className="section-industrial contact-industrial">
      <div className="contact-container">
        <div className="section-industrial-header">
          <h2 className="section-industrial-title contact-title">
            CONTACTO INDUSTRIAL
          </h2>
          <p className="section-industrial-subtitle contact-subtitle">
            Soporte técnico 24/7 para proyectos de cualquier magnitud
          </p>
        </div>
        
        <div className="contact-grid">
          <div className="contact-info">
            <h3 className="contact-section-title">
              CANALES DE CONTACTO
            </h3>
            
            <div className="contact-methods">
              {[
                { icon: '📞', label: 'LÍNEA DIRECTA', value: '+57 350 708 9584', type: 'tel' },
                { icon: '📧', label: 'EMAIL TÉCNICO', value: 'soporte@junisama.com', type: 'email' },
                { icon: '💬', label: 'WHATSAPP 24/7', value: 'Chat Inmediato', type: 'whatsapp' }
              ].map((contact, index) => (
                <div key={index} className="contact-method-card">
                  <span className="contact-icon">{contact.icon}</span>
                  <div>
                    <div className="contact-label">
                      {contact.label}
                    </div>
                    <div className={`contact-value ${contact.type === 'emergency' ? 'emergency' : ''}`}>
                      {contact.value}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="contact-form-section">
            <h3 className="contact-section-title">
              SOLICITAR COTIZACIÓN
            </h3>
            
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <input
                  type="text"
                  name="name"
                  placeholder="NOMBRE COMPLETO"
                  className="contact-input"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
                <input
                  type="text"
                  name="company"
                  placeholder="EMPRESA"
                  className="contact-input"
                  value={formData.company}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-row">
                <input
                  type="email"
                  name="email"
                  placeholder="EMAIL CORPORATIVO"
                  className="contact-input"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
                <input
                  type="tel"
                  name="phone"
                  placeholder="TELÉFONO"
                  className="contact-input"
                  value={formData.phone}
                  onChange={handleInputChange}
                />
              </div>

              <textarea
                name="message"
                placeholder="DETALLES DEL PROYECTO"
                rows={4}
                className="contact-textarea"
                value={formData.message}
                onChange={handleInputChange}
              />

              <button
                type="submit"
                className="btn-industrial btn-industrial-primary contact-submit"
                disabled={isSubmitting}
              >
                <span>◉</span>
                <span>{isSubmitting ? 'ENVIANDO...' : 'ENVIAR SOLICITUD'}</span>
              </button>

              {submitStatus === 'success' && (
                <p style={{ color: '#059669', marginTop: '1rem', textAlign: 'center' }}>
                  ¡Mensaje enviado! Te contactaremos pronto.
                </p>
              )}

              {submitStatus === 'error' && (
                <p style={{ color: '#dc2626', marginTop: '1rem', textAlign: 'center' }}>
                  Error al enviar. Intenta de nuevo o escríbenos por WhatsApp.
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactIndustrial;